module.exports = __webpack_public_path__ + "img/ambient-sleeping.642fd879.png";